var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("a", [
      _c("span", { staticClass: "modal-body-text" }, [
        _vm._v(
          "You are about to delete an event. If you choose to continue, you cannot recover your event."
        )
      ]),
      _c("br"),
      _c("br"),
      _vm._v(" "),
      _c("span", { staticClass: "modal-body-text" }, [
        _vm._v("Are you sure you want to continue?")
      ]),
      _vm._v(" "),
      _c("br")
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-0a72725a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0a72725a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/modal/DeleteEvent.vue
// module id = 1385
// module chunks = 1